import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { OfflineProvider } from './offline'
import './styles.css'

createRoot(document.getElementById('root')!).render(
  <OfflineProvider>
    <StrictMode>
      <BrowserRouter><App /></BrowserRouter>
    </StrictMode>
  </OfflineProvider>,
)
